<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'informes' }">{{ $t("informes") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("ventasPorOperarios") }}</li>
                    </ol>
                </nav>
            </div>
            <CabeceraInformes :idBusiness="idBusiness" :listBusinesses="listBusinesses" :idTpv="idTpv" :listTpv="listTpv"
                :dateto="dateto" :datefrom="datefrom" id="cabecera" :conTodos="true" />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <!--<div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="listBusiness">{{$t("negocio")}}</label>

                                <el-select class="select-default"
                                           size="large"
                                           v-model="idBusiness"
                                           filterable
                                           :placeholder="$t('seleccionaNegocio')"
                                           @change=" getSalesOperarios()">
                                    <el-option v-for="business in listBusinesses"
                                               class="select-primary"
                                               :value="business.id"
                                               :label="business.establishmentName"
                                               :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaInicio")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        format="dd-MM-yyyy"
                                        :title="$t('fechaInicio')"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="datefrom"></datetime>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div class="form-group">
                                <label>{{$t("fechaFin")}}</label>
                                <datetime
                                        value-zone="Europe/Madrid"
                                        :auto="true"
                                        class="theme-numier"
                                        :title="$t('fechaFin')"
                                        format="dd-MM-yyyy"
                                        :phrases="{ok: $t('aceptar'), cancel: $t('salir')}"
                                        input-class="form-control"
                                        v-model="dateto"></datetime>
                            </div>
                        </div>


                        <div class="col-md-2">
                            <label>&nbsp;</label>
                            <div class="form-group">
                                <button class="btn btn-primary" @click="getSalesOperarios()">
                                    <img src="static/img/sync.gif" alt="" v-if="loading" width="15">
                                    {{$t("consultar")}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->

            <template v-else-if="respuesta">
                <div class="col-md-8">
                    <template v-if="list.length > 0">
                        <div class="row justify-content-between div-export">

                            <div class="col-md-2 col-xs-12 text-right">
                                <el-dropdown>
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{ $t("exportarInforme") }} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdf") }}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item class="text-success">
                                                <strong>
                                                    <i class="fa fa-file-excel"></i> {{ $t("exportarExcel") }}
                                                </strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>

                            </div>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-bordered table-striped text-nowrap">
                                <thead class="thead-dark">
                                    <tr style="cursor: pointer;">
                                        <th v-if="ordenacionOperario === 0" @click="sortedArrayNameASC('workerName')"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{ $t("nombre") }}
                                        </th>
                                        <th v-else @click="sortedArrayNameDESC('workerName')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t("nombre") }}
                                        </th>
                                        <th v-if="ordenarImporte === 0" @click="sortedArrayImporteASC('amount')"><i
                                                style="color: white" class="fa fa-angle-up"></i> {{ $t("ventas") }}
                                        </th>
                                        <th v-else @click="sortedArrayImporteDESC('amount')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t("ventas") }}
                                        </th>
                                        <th v-if="ordenarInvitations === 0" @click="sortedArrayInvitationsASC('invitations')">
                                            <i style="color: white" class="fa fa-angle-up"></i> {{ $t("invitaciones") }}
                                        </th>
                                        <th v-else @click="sortedArrayInvitationsDESC('invitations')"><i
                                                style="color: white" class="fa fa-angle-down"></i> {{ $t("invitaciones") }}
                                        </th>
                                        <th v-if="ordenarEfectivo === 0" @click="sortedArrayEfectivoASC('invitations')">
                                            <i style="color: white" class="fa fa-angle-up"></i> {{ $t('efectivo') }}
                                        </th>
                                        <th v-else @click="sortedArrayEfectivoDESC('invitations')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t('efectivo') }}
                                        </th>
                                        <th v-if="ordenarTarjeta === 0" @click="sortedArrayTarjetaASC('invitations')">
                                            <i style="color: white" class="fa fa-angle-up"></i> {{ $t('tarjeta') }}
                                        </th>
                                        <th v-else @click="sortedArrayTarjetaDESC('invitations')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t('tarjeta') }}
                                        </th>
                                        <th v-if="ordenarCheque === 0" @click="sortedArrayChequeASC('invitations')">
                                            <i style="color: white" class="fa fa-angle-up"></i> {{ $t('cheque') }}
                                        </th>
                                        <th v-else @click="sortedArrayChequeDESC('invitations')"><i style="color: white"
                                                class="fa fa-angle-down"></i> {{ $t('cheque') }}
                                        </th>
                                        <th>{{ $t("acciones") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="obj in list">
                                        <td>{{ obj.workerName }}</td>
                                        <td class="text-right">{{ obj.amount | currency }} <span
                                                class="text-primary">({{ Math.round(100 / (getTotalVentas / obj.amount) * 100) / 100 }}%)
                                            </span></td>
                                        <td class="text-right">{{ obj.invitaciones }}</td>
                                        <td class="text-right">{{ obj.amountEfectivo | currency }} <span
                                                class="text-primary"><template
                                                    v-if="obj.amountEfectivo">({{ Math.round(100 / (obj.amount / obj.amountEfectivo) * 100) / 100 }}%)</template><template
                                                    v-else>(0%)</template> </span></td>
                                        <td class="text-right">{{ obj.amountTarjeta | currency }} <span
                                                class="text-primary"><template
                                                    v-if="obj.amountTarjeta">({{ Math.round(100 / (obj.amount / obj.amountTarjeta) * 100) / 100 }}%)
                                                </template><template v-else>(0%)</template></span></td>
                                        <td class="text-right">{{ obj.amountCheque | currency }} <span
                                                class="text-primary"><template
                                                    v-if="obj.amountCheque">({{ Math.round(100 / (obj.amount / obj.amountCheque) * 100) / 100 }}%)</template><template
                                                    v-else>(0%)</template></span></td>
                                        <td align="center">

                                            <router-link v-tooltip.top-center="$i18n.t('verProductosVendidos')"
                                                :to="{ name: 'ventas-productos-operarios', params: { idWorker: obj.idWorker, workerName: obj.workerName, idBusiness: idBusiness } }"
                                                class="btn btn-primary btn-link">
                                                <i class="fa fa-eye"></i>
                                            </router-link>

                                        </td>

                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="table-success">
                                        <td><strong>{{ $t("total") }}</strong></td>
                                        <td class="text-right"><strong>{{ getTotalVentas | currency }}</strong></td>
                                        <td class="text-right"><strong>{{ getTotalInvitaciones }}</strong></td>
                                        <td class="text-right"><strong>{{ getTotalEfectiva | currency }}</strong></td>
                                        <td class="text-right"><strong>{{ getTotalTarjeta | currency }}</strong></td>
                                        <td class="text-right"><strong>{{ getTotalCheque | currency }}</strong></td>
                                        <td></td>

                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </template>
                    <template v-else>
                        <div class="alert alert-danger" role="alert">
                            {{ $t("noHay") }} <strong>{{ $t('ventasPorOperarios') }}</strong> {{ $t("rangoDeFechas") }}
                        </div>
                    </template>
                </div>

                <div class="col-md-4 ">
                    <div class="card">
                        <div class="chart-container col-md-12 " style="height:40vh;">
                            <canvas id="chart"></canvas>
                        </div>

                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
import Chart from 'chart.js';
import { DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Loading } from 'element-ui'
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import swal from 'sweetalert2'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
    created() {
        this.loading = Loading.service({ text: "Cargando..." });
        this.$store.dispatch("setNameRoute", this.$i18n.t('ventasPorOperarios'));
        this.getBusiness();

        if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {

            this.datefrom = this.$store.getters.dateFrom;
            this.dateto = this.$store.getters.dateTo;

        }

    },
    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        CabeceraInformes
    },
    data() {
        return {
            loading: false,
            datefrom: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString(),
            dateto: new Date().toISOString(),
            listBusinesses: [],
            idBusiness: 0,
            list: [],
            mode: 0,
            objectChart: null,
            contador: 0,
            listTpv: [],
            idTpv: -1,
            dateRangeOptions1: {
                firstDayOfWeek: 1
            },

            ordenacionOperario: 0,
            ordenarImporte: 0,
            ordenarInvitations: 0,
            ordenarDifHora: 0,
            ordenarSueldo: 0,
            ordenarEfectivo: 0,
            ordenarTarjeta: 0,
            ordenarCheque: 0,

            respuesta: true,

        }
    },
    computed: {
        ...mapState(["permiso"]),
        urlExportPDF() {
            // return "../api/public/index.php/workers/exportVentasWorkers/PDF?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt

            let idTpvAMandar = "";

            if (this.idTpv == -1) {
                idTpvAMandar = 0;
            } else {
                idTpvAMandar = this.idTpv;
            }

            return this.$store.getters.apiUrl + "/workers/exportVentasWorkers/PDF?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


        },
        urlExportExcel() {
            let idTpvAMandar = "";

            if (this.idTpv == -1) {
                idTpvAMandar = 0;
            } else {
                idTpvAMandar = this.idTpv;
            }

            return this.$store.getters.apiUrl + "/workers/exportVentasWorkers/Excel?idBusiness=" + this.idBusiness + "&idTpv=" + idTpvAMandar + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt


        },

        getTotalVentas() {
            let total = 0;
            this.list.forEach(function (d) {

                total += d.amount;
            });
            return total;
        },


        getTotalInvitaciones() {
            let total = 0;
            this.list.forEach(function (d) {
                total += d.invitaciones;
            });
            return total;
        },

        getTotalEfectiva() {
            let total = 0;
            this.list.forEach(function (d) {
                total += d.amountEfectivo;
            });
            return total;
        },

        getTotalTarjeta() {
            let total = 0;
            this.list.forEach(function (d) {
                total += d.amountTarjeta;
            });
            return total;
        },

        getTotalCheque() {
            let total = 0;
            this.list.forEach(function (d) {
                total += d.amountCheque;
            });
            return total;
        }


    },
    methods: {

        cambioBusiness(idBusinessData, listTpv) {
            if (listTpv) {
                this.listTpv = listTpv;
            }


            this.loading = Loading.service({ text: "Cargando..." });
            this.idBusiness = idBusinessData;
            this.idTpv = -1;
            this.list = [];
            this.cambioTpv(this.idTpv);
        },

        emitirConsulta() {
            this.loading = Loading.service({ text: "Cargando..." });
            this.getSalesOperarios();
        },

        cambioTpv(idTpvData, filtrar) {

            if (idTpvData != undefined) {
                this.idTpv = idTpvData;
            }

            this.idTpv = idTpvData;
            this.emitirConsulta();
        },

        cambioHora(dates) {
            this.datefrom = dates[0]
            this.dateto = dates[1]
        },

        sortedArrayNameASC: function () {
            this.ordenacionOperario = 1;

            function compare(a, b) {
                if (a.workerName.toUpperCase() < b.workerName.toUpperCase())
                    return -1;
                if (a.workerName.toUpperCase() > b.workerName.toUpperCase())
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayEfectivoASC: function () {
            this.ordenarEfectivo = 1;

            function compare(a, b) {
                if (a.amountEfectivo < b.amountEfectivo)
                    return -1;
                if (a.amountEfectivo > b.amountEfectivo)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArrayTarjetaASC: function () {
            this.ordenarTarjeta = 1;

            function compare(a, b) {
                if (a.amountTarjeta < b.amountTarjeta)
                    return -1;
                if (a.amountTarjeta > b.amountTarjeta)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArrayChequeASC: function () {
            this.ordenarCheque = 1;

            function compare(a, b) {
                if (a.amountCheque < b.amountCheque)
                    return -1;
                if (a.amountCheque > b.amountCheque)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArrayNameDESC: function () {
            this.ordenacionOperario = 0;

            function compare(a, b) {

                if (a.workerName.toUpperCase() > b.workerName.toUpperCase())
                    return -1;
                if (a.workerName.toUpperCase() < b.workerName.toUpperCase())
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayImporteASC: function () {
            this.ordenarImporte = 1;

            function compare(a, b) {
                if (a.amount < b.amount)
                    return -1;
                if (a.amount > b.amount)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayImporteDESC: function () {
            this.ordenarImporte = 0;

            function compare(a, b) {

                if (a.amount > b.amount)
                    return -1;
                if (a.amount < b.amount)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArrayInvitationsASC: function () {
            this.ordenarInvitations = 1;

            function compare(a, b) {
                if (a.invitaciones < b.invitaciones)
                    return -1;
                if (a.invitaciones > b.invitaciones)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayInvitationsDESC: function () {
            this.ordenarInvitations = 0;

            function compare(a, b) {

                if (a.invitaciones > b.invitaciones)
                    return -1;
                if (a.invitaciones < b.invitaciones)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayEfectivoDESC: function () {
            this.ordenarEfectivo = 0;

            function compare(a, b) {

                if (a.amountEfectivo > b.amountEfectivo)
                    return -1;
                if (a.amountEfectivo < b.amountEfectivo)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayTarjetaDESC: function () {
            this.ordenarTarjeta = 0;

            function compare(a, b) {

                if (a.amountTarjeta > b.amountTarjeta)
                    return -1;
                if (a.amountTarjeta < b.amountTarjeta)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayChequeDESC: function () {
            this.ordenarCheque = 0;

            function compare(a, b) {

                if (a.amountCheque > b.amountCheque)
                    return -1;
                if (a.amountCheque < b.amountCheque)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayDifHoraASC: function () {
            this.ordenarDifHora = 1;

            function compare(a, b) {
                if (a.diffHora < b.diffHora)
                    return -1;
                if (a.diffHora > b.diffHora)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArrayDifHoraDESC: function () {
            this.ordenarDifHora = 0;

            function compare(a, b) {

                if (a.diffHora > b.diffHora)
                    return -1;
                if (a.diffHora < b.diffHora)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        sortedArraySueldoASC: function () {
            this.ordenarSueldo = 1;

            function compare(a, b) {
                if (a.import < b.import)
                    return -1;
                if (a.import > b.import)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },
        sortedArraySueldoDESC: function () {
            this.ordenarSueldo = 0;

            function compare(a, b) {

                if (a.import > b.import)
                    return -1;
                if (a.import < b.import)
                    return 1;
                return 0;
            }

            return this.list.sort(compare);
        },

        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {

                    vm.listBusinesses = response.data.result;

                    if (vm.$store.getters.idBusiness) {
                        vm.idBusiness = vm.$store.getters.idBusiness;
                    } else {

                        vm.idBusiness = response.data.result[0].id;
                    }

                    //vm.getSalesOperarios();
                    vm.getTpv();

                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getTpv() {

            this.listTpv = [];

            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {


                        for (let i = 0; i < response.data.result.length; i++) {
                            vm.idsTPV.push(response.data.result[i].id)
                        }

                        vm.listCheckBoxTpv = response.data.result;


                        for (let i = 0; i < response.data.result.length; i++) {

                            let printername = {
                                nameShow: response.data.result[i].nameShow,
                                id: response.data.result[i].id
                            };

                            vm.listTpv.push(printername)
                        }

                        vm.getSalesOperarios();


                    }


                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getSalesOperarios() {

            if (this.datefrom === null || this.dateto === null) {
                swal({
                    title: this.$t('ups'),
                    text: this.$t('seleccioneUnaFechaDeInicioYUnaFechaDeFin'),
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

                this.loading.close();
            } else {

                let secondsDesde = moment(this.datefrom).unix();
                let secondsHasta = moment(this.dateto).unix();

                if (secondsHasta < secondsDesde) {
                    swal({
                        title: this.$t('ups'),
                        text: this.$t('laFechaDeInicioNoPuedeSerPosteriorALaDeFin'),
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                    this.loading.close();
                } else {

                    this.$store.dispatch("setDateTo", this.dateto);
                    this.$store.dispatch("setDateFrom", this.datefrom);

                    let idTpvAMandar = "";

                    if (this.idTpv == -1) {
                        idTpvAMandar = 0;
                    } else {
                        idTpvAMandar = this.idTpv;
                    }

                    var config = {
                        params: {
                            idBusiness: this.idBusiness,
                            idTpv: idTpvAMandar,
                            datefrom: moment(this.datefrom).startOf("day").unix(),
                            dateto: moment(this.dateto).endOf("day").unix(),
                            jwt: this.$store.getters.jwt,
                            desde: 1,
                        },
                        headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
                    };

                    this.loading.close();

                    let vm = this;
                    this.$store.dispatch("setIdBusiness", this.idBusiness);
                    this.axios.get(this.$store.getters.apiUrl + "workers/getRankingWorkers", config)
                        .then(function (response) {
                            if (response.data.response) {

                                vm.list = response.data.result;
                                vm.respuesta = true;

                                vm.initChart()
                            } else if (response.data.response == false && response.data.rangoMayor == true) {
                                swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                });
                                vm.respuesta = false;
                            } else {
                                swal({
                                    title: $t('accesoDenegado'),
                                    text: response.data.message,
                                    confirmButtonClass: 'btn btn-info btn-fill',
                                    type: 'error'
                                });

                                vm.respuesta = false;

                            }
                            vm.loading.close();

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            }
        },


        initChart() {


            var labels = this.list.map(function (x) {
                return x.workerName;
            });

            var data = this.list.map(function (x) {
                return x.amount;
            });


            var randomColor = require('randomcolor');

            var colors = randomColor({ luminosity: 'dark', count: labels.length, format: 'rgb' });

            let backgroundColors = colors.map(function (x) {
                let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)";
            });

            let borderColors = colors.map(function (x) {
                let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)";
            });

            let hoverBackgroundColors = colors.map(function (x) {
                let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
                return "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)";
            });

            if (this.contador == 0) {

                if (this.list.length > 0) {
                    this.objectChart = new Chart("chart", {

                        type: 'bar',
                        data: {
                            labels: labels,
                            datasets: [{
                                label: this.$t('ventas'),
                                data: data,
                                backgroundColor: backgroundColors,
                                borderColor: borderColors,
                                hoverBackgroundColor: hoverBackgroundColors,
                                borderWidth: 1
                            }]
                        },
                        options: {

                            scales: {
                                yAxes: [{
                                    ticks: {
                                        beginAtZero: true
                                    }
                                }]
                            },

                            responsive: true,
                            maintainAspectRatio: false,

                        }
                    });


                    this.contador++;
                }
            } else {

                this.objectChart.destroy();

                this.objectChart = new Chart("chart", {

                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [{
                            data: data,
                            label: this.$t('ventas'),
                            backgroundColor: backgroundColors,
                            borderColor: borderColors,
                            hoverBackgroundColor: hoverBackgroundColors,
                            borderWidth: 1
                        }]
                    },
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                        responsive: true,
                        maintainAspectRatio: false

                    }
                });

            }
        }
    }
}
</script>

<style scoped>
a li {
    color: #111;
}

.card {
    padding: 20px;
}

.div-export {
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Operarios/VentasPorOperarios.vue